export default "__VITE_ASSET__qULUXu0$__"